import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup }
from 'react-simple-animate';
import ThisDriversCurrentExcesses
  from './this-drivers-current-excesses.jsx';
import ThisDriversArchivedExcesses
  from './this-drivers-archived-excesses.jsx';
  import DatePicker from 'react-datepicker';
import moment from 'moment';
export default class DriverExcess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: props.data || [],
      expanded: false,
      newExcessFormVisible: false,
      play: false,
      selected_start_date:null,
      selected_end_date:null,
      selected_daily_date:null,
      selected_hourly_date_stime:null,
      selected_hourly_date_etime:null,
      deduction_occurance:'weekly'
    };

    this.handleButtonClicked = this.
    handleButtonClicked.bind(this);
    this.handleAddNewExcessFormSubmitButtonClick = this.
    handleAddNewExcessFormSubmitButtonClick.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleDailyDateChange = this.handleDailyDateChange.bind(this);
    this.handleHourlyDateSTimeChange = this.handleHourlyDateSTimeChange.bind(this);
    this.handleHourlyDateETimeChange = this.handleHourlyDateETimeChange.bind(this);
    this.handleDeductionOccurance = this.handleDeductionOccurance.bind(this);
  }

  handleButtonClicked(variable) {
    $("#driver-expanded-excesses-list-"+variable).slideToggle(200);
    this.setState({expanded: !this.state.expanded})
  }
  handleStartDateChange(date) {
    this.setState({selected_start_date: date})
  }
  handleEndDateChange(date) {
    this.setState({selected_end_date: date})
  }
  handleDailyDateChange(date) {
    this.setState({selected_daily_date: date})
  }
  handleHourlyDateSTimeChange(date) {
    this.setState({selected_hourly_date_stime: date})
  }
  handleHourlyDateETimeChange(date) {
    this.setState({selected_hourly_date_etime: date})
  }
  handleDeductionOccurance(e){
    this.setState({deduction_occurance: e.target.value})
  }
  handleAddNewExcessButtonClick() {
    this.setState({
      newExcessFormVisible: !this.state.newExcessFormVisible
    });
  }

  handleAddNewExcessFormSubmitButtonClick(e) {
    e.preventDefault();
    let addNewExcessData = {
      api_token: window.api_token,
      driver_id: this.state.data.driver.id,
      description: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=description]'
      ).val(),
      insurance_reference: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=insurance_reference]'
      ).val(),
      original_amount_to_repay: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=original_amount_to_repay]'
      ).val(),
      deduction_occurance: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=deduction_occurance]'
      ).val(),
      agreed_deduction_amount: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=agreed_deduction_amount]'
      ).val(),
      start_date: (this.state.selected_start_date != null) ? moment(this.state.selected_start_date).format("YYYY-MM-DD") : null,
      end_date: (this.state.selected_end_date != null) ? moment(this.state.selected_end_date).format("YYYY-MM-DD") : null,
      selected_day: (this.state.selected_daily_date != null) ? moment(this.state.selected_daily_date).format("YYYY-MM-DD") : null,
      selected_starttime: (this.state.selected_hourly_date_stime) ? moment(this.state.selected_hourly_date_stime).format("YYYY-MM-DD h:mm a") : null,
      selected_endtime: (this.state.selected_hourly_date_etime != null) ? moment(this.state.selected_hourly_date_etime).format("YYYY-MM-DD h:mm a"): null,
    };

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/drivers/excesses/add-new-excess',
      data: addNewExcessData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status == 200) {
          $('#infomodallabel').html('New Excess Created');
          $('#infomodal .modal-body').html('New Excess Created');
          $('#infomodal').modal();
          $('input').val('');
          $('textarea').val('');
          $('select').val('');
        }
        else {
          $('#infomodallabel').html('Error adding new excess');
          $('#infomodal .modal-body').html($.parseHTML(
            response.responseText.
            replace(/\"/g, ""))
          );
          $('#infomodal').modal();
        }
      }
    });
  }

  componentDidMount() {
    this.setState({
      play: true
    });
  }


  render() {
    return (
      <div className={"driver-excess-account-container"+
      (this.state.expanded ? ' excess-container-expanded ' : '')}>
         <div
          className="row"
          onDoubleClick={() => {
              this.handleButtonClicked(this.state.data.id)
          }}>
          <div className="col-md-1 text-left">
            <img
              src={"/user-images/"+this.state.data.id}
              className="driver-excesses-table-driver-image"
            />
          </div>

          <div className="col-md-4">
            <h3>
              <a href={"/portal-admin/users/view/"+this.state.data.id}>
                {this.state.data.first_name} {this.state.data.last_name}
              </a>
            </h3>
          </div>

          <div className="col-md-5">
            <h3>
            &pound;{this.state.data.excess_total_paid_amount} /
            &pound;{this.state.data.excess_total_amount}
            </h3>
          </div>

          <div className="col-md-2 text-right">
            <button
              onClick={(e) => {
                this.handleButtonClicked(this.state.data.id)
              }}
              className="btn btn-lg btn-default">
              Excesses {(this.state.expanded ?
                <i className="fa fa-times"></i>:
                <i className="fa fa-level-down-alt"></i>)}
            </button>
          </div>
        </div>

        <div
          className="container driver-expanded-excesses-list"
          id={"driver-expanded-excesses-list-"+this.state.data.id}>
          <div className="row">
          <div className="col-md-6">
          <div className="row">
          <div className="col-md-6">
            <h2>Current Excesses</h2>
          </div>
          <div className="col-md-6">
          <button className="btn btn-sm btn-dark"
               onClick={(e) => {
                 this.handleAddNewExcessButtonClick(this.state.data.id)
               }}>
              {(this.state.newExcessFormVisible ?
                <i className="fa fa-minus"></i>:
                <i className="fa fa-plus"></i>)
              } Add New Excess
              </button>
            </div>
            </div>

          {(this.state.newExcessFormVisible ?
            <Animate
              play={this.state.play}
              start={{opacity: 0}}
              end={{opacity: 1}}
              className="driver-excess-form-container"
            >
            <form id={"new_excess_for_user"+this.state.data.id}>
              <fieldset>
                  <div className="row">
                    <div className="col-md-6 text-right">
                      Description
                    </div>
                    <div className="col-md-6 text-left">
                    <input
                    className="form-control form-control-lg"
                    name="description"
                    type="text" placeholder="description" />
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6 text-right">
                    Reference
                    </div>
                    <div className="col-md-6 text-left">
                    <input
                    className="form-control form-control-lg"
                    name="insurance_reference"
                    type="text" placeholder="reference" />
                    </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 text-right">
                        Amount to Repay:
                      </div>
                      <div className="col-md-6 text-left">
                    <input
                    className="form-control form-control-lg"
                    name="original_amount_to_repay"
                     type="text" placeholder="&pound; original amount to repay" />
                   </div>
                    </div>
                <div className="row">
                    <div className="col-md-6 text-right">
                    @
                    </div>
                    <div className="col-md-6 text-left">
                      <input type="text" placeholder="&pound;agreed deduction amount"
                      name="agreed_deduction_amount" id="agreed_deduction_amount"
                      className="form-control" />
                     per <select name="deduction_occurance" id="deduction_occurance" onChange={this.handleDeductionOccurance}>
                      <option value="weekly">Week</option>
                      <option value="monthly">Month</option>
                      <option value="daily">Day</option>
                      <option value="hourly">Hour</option>
                    </select><br />
                    </div>
                </div>
                { this.state.deduction_occurance == 'weekly' ? 
                <div className="weekly">
                  <div className="row">
                      <div className="col-md-6 text-right">
                          Start Date:
                      </div>
                      <div className="col-md-6 text-left">
                          <DatePicker todayButton={"Today"} dateFormat="yyyy-MM-dd" onChange={this.handleStartDateChange} selected={this.state.selected_start_date}/>
                    </div>
                  </div>
                  <div className="row">
                      <div className="col-md-6 text-right">
                          End Date:
                      </div>
                      <div className="col-md-6 text-left">
                          <DatePicker todayButton={"Today"} dateFormat="yyyy-MM-dd" onChange={this.handleEndDateChange} selected={this.state.selected_end_date}/>
                    </div>
                  </div>
                </div> : ''}
                { this.state.deduction_occurance == 'daily' ? 
                <div className="daily">
                  <div className="row">
                      <div className="col-md-6 text-right">
                          Select Day:
                      </div>
                      <div className="col-md-6 text-left">
                          <DatePicker todayButton={"Today"} dateFormat="yyyy-MM-dd" onChange={this.handleDailyDateChange} selected={this.state.selected_daily_date}/>
                      </div>
                  </div>
                </div> : ''}
                { this.state.deduction_occurance == 'hourly' ? 
                <div className="hourly">
                  <div className="row">
                      <div className="col-md-6 text-right">
                          Select Start Time:
                      </div>
                      <div className="col-md-6 text-left">
                          <DatePicker todayButton={"Today"} timeInputLabel="Time:" dateFormat="yyyy-MM-dd h:mm aa" showTimeInput onChange={this.handleHourlyDateSTimeChange} selected={this.state.selected_hourly_date_stime}/>
                      </div>
                  </div>
                  <div className="row">
                      <div className="col-md-6 text-right">
                          Select End Time:
                      </div>
                      <div className="col-md-6 text-left">
                          <DatePicker todayButton={"Today"} timeInputLabel="Time:" dateFormat="yyyy-MM-dd h:mm aa" showTimeInput onChange={this.handleHourlyDateETimeChange} selected={this.state.selected_hourly_date_etime}/>
                      </div>
                  </div>
                </div> : ''}
                <div className="row">
                    <div className="col-md-6 text-right">&nbsp;</div>
                    <div className="col-md-6 text-left">
                    <button className="btn btn-sm btn-primary"
                      onClick={(e) => {
                        this.handleAddNewExcessFormSubmitButtonClick(e)
                      }}>
                      <i className="fa fa-plus"></i> Add New Excess</button>
                    </div>
                    <br/>
                </div>
              </fieldset>
            </form>
            <br/>
          </Animate>
          :'')}

             <ThisDriversCurrentExcesses
               excessAccountId={
                 this.state.data.driver.excess_account_id
               }
             />
          </div>

          <div className="col-md-6">
            <h2>Archived Excesses</h2>
            <ThisDriversArchivedExcesses
              excessAccountId={
                this.state.data.driver.excess_account_id
              }
            />
          </div>
          </div>
        </div>
      </div>
    );
  }
}
